interface Notification {
    title: string;
    msg: string;
    timeout: number;
    theme?: string;
    showClose: boolean;
    type?: NotificationType;
    id: string;
}

enum NotificationType {
    Success = 1,
    Warning = 2,
    Error = 3
}

export {
    Notification,
    NotificationType
};
